import React from "react";
import { motion } from "framer-motion";

const stats = [
  { k: "97%", v: "AUC — performance diagnostique" },
  { k: "100 000+", v: "Patients dans les études cliniques" },
  { k: "~15 min", v: "Résultat au point de soin" },
  { k: "FDA · CE", v: "510(k) cleared · marquage CE" },
];

const Stats = () => {
  return (
    <section
      data-testid="stats-section"
      className="relative py-16 md:py-20 border-y border-white/5 bg-[#0A1128]/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((s, i) => (
          <motion.div
            key={s.k}
            data-testid={`stat-${i}`}
            className="text-center md:text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="font-display text-3xl md:text-4xl font-semibold text-white tracking-tight">
              {s.k}
            </div>
            <div className="text-sm text-slate-400 mt-2 tracking-wide leading-snug">
              {s.v}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
